import { useEffect, useRef, useState } from 'react'

import type { MarkupSurface } from './types'
import { getFittedPageWidth, getMarkupEditorRenderSettings } from './viewport'

const INITIAL_ZOOM = 1

export function useMarkupEditorViewport(surface: MarkupSurface) {
  const viewport = useRef<HTMLDivElement>(null)
  const [fittedWidth, setFittedWidth] = useState<number>()
  const [zoom, setZoom] = useState(INITIAL_ZOOM)

  useEffect(() => {
    const element = viewport.current
    if (!element) return
    const updateWidth = () => {
      const width = element.clientWidth
      if (width > 0) setFittedWidth(getFittedPageWidth(width))
    }
    updateWidth()
    if (typeof ResizeObserver === 'undefined') return
    const observer = new ResizeObserver(updateWidth)
    observer.observe(element)
    return () => observer.disconnect()
  }, [surface.id])

  const renderSettings = fittedWidth
    ? getMarkupEditorRenderSettings(
        fittedWidth,
        { width_points: surface.width, height_points: surface.height },
        zoom,
        window.devicePixelRatio || 1
      )
    : undefined

  return {
    viewport,
    zoom,
    setZoom,
    renderSettings,
    display: {
      width: renderSettings?.pageWidth ?? 1,
      height: renderSettings
        ? (renderSettings.pageWidth * surface.height) / surface.width
        : 1,
    },
  }
}
